import type OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import type MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import setMailboxJunkEmailConfigurationOperation from 'owa-service/lib/operation/setMailboxJunkEmailConfigurationOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getMailboxRequestOptions from 'owa-service/lib/getMailboxRequestOptions';
import type { MailboxInfo } from 'owa-client-types';

export enum JunkEmailConfigurationErrorCode {
    None,
    Unknown,
    SameOrg,
}

export async function setMailboxJunkEmailConfiguration(
    options: MailboxJunkEmailConfigurationOptions,
    mailboxInfo: MailboxInfo
): Promise<JunkEmailConfigurationErrorCode> {
    const requestOptions = getMailboxRequestOptions(mailboxInfo);
    const serviceOperation = setMailboxJunkEmailConfigurationOperation(
        {
            Header: getJsonRequestHeader(),
            Options: options,
        },
        requestOptions
    );

    return serviceOperation
        .then((response: OptionsResponseBase) => {
            if (response.WasSuccessful) {
                return JunkEmailConfigurationErrorCode.None;
            } else {
                if (!!response.ErrorMessage?.includes('IsInternalToOrganization')) {
                    return JunkEmailConfigurationErrorCode.SameOrg;
                }
                return JunkEmailConfigurationErrorCode.Unknown;
            }
        })
        .catch(() => {
            return JunkEmailConfigurationErrorCode.Unknown;
        });
}
